import { useEffect, useState } from 'react';
import style from './Wrapper.module.scss';

const Wrapper = props => {
  const [classNames, setClassNames] = useState(style.wrapper);
  useEffect(() => {
    if (props.className) {
      setClassNames(style.wrapper + ' ' + props.className);
    }
  }, [props]);
  return (
    <div
      className={
        classNames
        // + " " + props.className ? props.className : ""
      }
    >
      {props.children}
    </div>
  );
};

export default Wrapper;
